import styled from 'styled-components';
import { panel, cardSurface, accent } from '../../UI/tokens';
export const CardContainer = styled.div`
  ${panel}
  ${cardSurface}
  border-left: 3px solid ${accent}; padding: 16px; margin-bottom: 12px;
  font-family: var(--ui-font); font-size: 13px; line-height: 1.65;
  height: 168px; min-height: 168px; overflow-y: auto;
  overflow-wrap: anywhere; cursor: pointer;
  &:hover { box-shadow: 0 5px 16px rgba(15,23,42,.12); }
`;
